import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import { GiftCardManagement } from "./GiftCards";

export default function GiftCardManagementPages() {
  return (
    <>
      <AsideMenu>
        <UserGroupMenu destination="/gift-cards" />
      </AsideMenu>
      <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            <ContentRoute path="/gift-cards/:userGroup" component={GiftCardManagement} />
          </Switch>
        </Suspense>
      </Section>
    </>
  );
}
